import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'

export default class SomeParticle extends Phaser.GameObjects.Image
{
    /**
     * 
     * @param {Phaser.Scene} scene
     */
    constructor(scene)
    {
        super(scene, 0, 0, ABCyaPhaser.Images.DEFAULT_ATLAS, "star_on");
    }

    reset(x, y, startFrame)
    {
        this.x = x;
        this.y = y;
        this.alpha = 1;
        this.scale = Phaser.Math.Between(4, 10) / 10;
        let speed = 1;
        let a = Math.PI * 2 * Math.random();
        let v = (Math.random() - 0.5) * 30 * speed;
        this.vX = Math.cos(a) * v;
        this.vY = Math.sin(a) * v;
        this.vS = (Math.random() - 0.5) * 0.2;
        this.setFrame(startFrame);
    }

    tick() {
        // apply gravity and friction
        this.vY += 0.5;
        this.vX *= 0.98;

        // update position, scale, and alpha:
        this.x += this.vX;
        this.y += this.vY;
    }
}